export default "__VITE_ASSET__BkH_CQIz__"